import { axios, handleApiError } from "./Api";

const ReportsApi = {
    /**
     * Send report file by email
     * 
     * @param {String} report
     * @param {String} email
     * @param {String} subject
     * @param {String} body
     * @param {Object} meta
     * 
     */
    async emailReport(report, email, subject, body, meta = {}) {
        const emailData = {
            email: email,
            subject: subject,
            body: body,
            report: report,
            meta: meta
        }

        return axios.post(axios.defaults.baseURL + "/reports/email", emailData).then(response => {
            return response.data;
        }).catch(handleApiError);
  }
};

export default ReportsApi;
